import { Routes, Route } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import Createproject from "./pages/Admin/Project";
import Approval from "./pages/Admin/LeaveapprovalAdmin";
import Reviewwfhadmin from "./pages/Admin/Reviewwfhadmin";
import Requirements from "./pages/Admin/Requirements";
import EmployeeListAdmin from "./pages/Admin/EmployeeListAdmin";
import EmployeeFormAdmin from "./pages/Admin/EmployeeFormAdmin";
import Salarymanagement from "./pages/Admin/Salarymanagement";
import Salarydata from "./pages/Admin/Salarydata";
import Performance from "./pages/Admin/Performanceemployeelist";
import Perfomanceevaluation from "./pages/Admin/Perfomanceevaluation";
import AttandancecalendraAdmin from "./pages/Admin/AttandancecalendraAdmin";
import ExpenseDashboardAdmin from "./pages/Admin/ExpenseDashboardAdmin";
import ViewSalaryExpenseAdmin from "./pages/Admin/ViewSalaryExpenseAdmin";
import Viewvendorbill from "./pages/Admin/Viewvendorbill";
import AddVendorBill from "./pages/Admin/Addvendorbill";
import Payrollprocesssalary from "./pages/Admin/Payrollprocesssalary";
import Payments from "./pages/Admin/Payments";
import Payouthistory from "./pages/Admin/Payouthistory";
import Expensepayroll from "./pages/Admin/Expensepayroll";
import Salaryarrear from "./pages/Admin/Salaryarrear";
import Accountledger from "./pages/Admin/Accountledger";
import OfficeInventory from "./pages/Admin/OfficeInventory";
import ItemsofficeInventory from "./pages/Admin/ItemsofficeInventory";
import AddLeaveWFH from "./pages/Admin/EmployeeLeave";
import Reviewwfh from "./pages/Admin/Reviewwfh";
import PayrollAdminAccess from "./pages/Admin/PayrollAdminAccess";
import Createworkspaceadmin from "./pages/Admin/Createworkspaceadmin";
import Taskmanagementadmin from "./pages/Admin/Taskmanagementadmin";
import Subtaskadmin from "./pages/Admin/Subtaskadmin";
import Activity from "./pages/Admin/Activity";
import Subtasks from "./pages/Admin/Subtasks";
import Taskoverview from "./pages/Admin/Taskoverview";
import Privacypolicy from "./pages/Admin/Privacypolicy";
import Inactiveemployee from "./pages/Admin/Inactiveemployee";
import Adminsetting from "./pages/Admin/Adminsetting";
import Balanceleave from "./pages/Admin/Balanceleave";
import LoginHandler from "./pages/LoginHandler";
import HRDashboard from "./pages/Hr/HRDashboard";
import EmployeeManagementHR from "./pages/Hr/EmployeelistHR";
import EmployeeFormHR from "./pages/Hr/EmployeeFormHR";
import Salarymanagementhr from "./pages/Hr/Salarymanagementhr";
import Salarydatahr from "./pages/Hr/Salarydata";
import AttandancecalendraHR from "./pages/Hr/AttandancecalendraHR";
import OfficeInventoryhr from "./pages/Hr/OfficeInventoryhr";
import ItemsofficeInventoryhr from "./pages/Hr/ItemsofficeInventoryhr";
import Balanceleavehr from "./pages/Hr/Balanceleavehr";
import Approvalhr from "./pages/Hr/Approvalhr";
import AddLeaveWFHhr from "./pages/Hr/Addleave";
import Reviewwfhhr from "./pages/Hr/Reviewwfhhr";
import ExpenseDashboardHR from "./pages/Hr/ExpenseDashboardHR";
import ViewSalaryExpenseHR from "./pages/Hr/ViewSalaryExpenseHR";
import Payrollprocesssalaryhr from "./pages/Hr/Payrollprocesssalaryhr";
import Expensepayrollhr from "./pages/Hr/ExpensePayrollHR";
import Salaryarrearhr from "./pages/Hr/Salaryarrearhr";
import AccountledgerHR from "./pages/Hr/AccountledgerHR";
import Privacypolicyhr from "./pages/Hr/Privacypolicy";
import Inactiveemployeehr from "./pages/Hr/Inactiveemployee";
import Hrsetting from "./pages/Hr/Hrsetting";
import EmployeeDashboard from "./pages/Employee/EmployeeDashboard";
import Perfomance from "./pages/Employee/Perfomance";
import Salaryslipemployee from "./pages/Employee/Salaryslipemployee";
import TrackingEmployee from "./pages/Employee/TrackingEmployee";
import ViewEmployeeprofile from "./pages/Employee/ViewEmployeeprofile";
import EmployeeAttendance from "./pages/Employee/EmployeeAttendance";
import ExpenseDashboardemployee from "./pages/Employee/ExpenseDashboardemployee";
import Viewexpanseemployee from "./pages/Employee/Viewexpanseemployee";
import EmployeeLeave from "./pages/Employee/EmployeeLeave";
import Reviewwfhupdate from "./pages/Employee/Reviewwfh";
import Createworkemployee from "./pages/Employee/Createworkemployee";
import WorkDashboardnew from "./pages/Employee/WorkDashboardnew";
import Employeeworkspace from "./pages/Employee/Employeeworkspace";
import { Subtask } from "./pages/Employee/Subtask";
import Subtasksemployee from "./pages/Employee/Subtasks";
import Activityemployee from "./pages/Employee/Activityemployee";
import TaskOverview from "./pages/Employee/Taskoverview";
import Privacypolicyemp from "./pages/Employee/Privacypolicyemp";
import EPFcalculator from "./pages/Employee/EPFcalculator";
import Employeesetting from "./pages/Employee/Employeesetting";
import Contract from "./pages/Employee/Contract";
import Wfhworkupdate from "./pages/Employee/Wfhworkupdate";
import ProtectedRoute from "./components/ProtectedAdminRoute";
import Approvalleave from "./pages/Employee/Leaveaproval";
import Wfhworkupdateadmin from "./pages/Admin/Wfhworkupdate";
import Bulkexcelattendance from "./pages/Admin/Bulkexcelattendance";
import Contracthr from "./pages/Hr/Hrcontract";
import Contractadmin from "./pages/Admin/Admincontract";
import Rwabulkexcelattendance from "./pages/Admin/Rawattendance";
import Rwabulkexcelattendancehr from "./pages/Hr/Rawattendance";
import Taskoverviewhr from "./pages/Hr/Taskoverview";
import Loanmanagement from "./pages/Admin/Loanmangement";
import Manageloan from "./pages/Admin/Manageloan";
import Loanmanagementemployee from "./pages/Employee/Loanmangement";
import Superadmindashboard from "./pages/Superadmin/Dashboard";
import Firmdashboard from "./pages/Superadmin/Firmdashboard";
import Firmdaccess from "./pages/Superadmin/Firmaccess";
import Loginqueries from "./pages/Superadmin/Loginqueries";
import Reacentqueries from "./pages/Superadmin/RecentQuery";
import Filesharing from "./pages/Employee/File";
import Filesharingadmin from "./pages/Admin/adminfilesharing";
import EmployeeFormAdminWidgetPage from "./widgets/employee-form/EmployeeFormAdminWidgetPage";


const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LoginHandler />} />
    <Route
      path="/widget/employee-form"
      element={<EmployeeFormAdminWidgetPage />}
    />
    <Route path="/" element={<DashboardLayout />}>
      <Route
        path="/admin/Review_Wfh_Work"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Reviewwfhadmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Project_Requirements"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Requirements />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/EmployeeFormAdmin"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <EmployeeFormAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Bulkexcelattendance"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Bulkexcelattendance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/raw-attendance"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Rwabulkexcelattendance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/LeaveApprovalAdmin"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Approval />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Createproject"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Createproject />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/AdminDashboard"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/employee-management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <EmployeeListAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/salary-management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Salarymanagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/loan-management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Loanmanagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Salary_data"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Salarydata />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-loan"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Manageloan />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/file"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
             <Filesharingadmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/performance"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Performance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/ViewSalaryExpenseAdmin"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <ViewSalaryExpenseAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Perfomance-evaluation"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Perfomanceevaluation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/attendance-management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <AttandancecalendraAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/expense-management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <ExpenseDashboardAdmin />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/View-Vendor-Bill"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Viewvendorbill />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Add-Vendor-bill"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <AddVendorBill />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/payroll-management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Payrollprocesssalary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Payments"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Payments />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Payout-History"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Payouthistory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/expense-payroll"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Expensepayroll />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/arrear"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Salaryarrear />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/account-ledger"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Accountledger />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/office-inventory"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <OfficeInventory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Items-office-Inventory"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <ItemsofficeInventory />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-leave-wfh"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <AddLeaveWFH />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Review-Wfh"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Reviewwfh />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/access"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <PayrollAdminAccess />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-workspace"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Createworkspaceadmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Task-management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Taskmanagementadmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Subtask-management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Subtaskadmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Activity-Management"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Activity />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Subtasks"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Subtasks />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/task-overview"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Taskoverview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/policy"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Privacypolicy />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Wfh_Work"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Wfhworkupdateadmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/inactive-employee"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Inactiveemployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/admin-settings"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Adminsetting />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Contract"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Contractadmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/Balance-leave"
        element={
          <ProtectedRoute allowedTypes={["A"]}>
            <Balanceleave />
          </ProtectedRoute>
        }
      />

      {/* hr routes */}
      <Route
        path="/Hr/HRDashboard"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <HRDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/EmployeeManagement"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <EmployeeManagementHR />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/raw-attendance"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Rwabulkexcelattendancehr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/EmployeeFormhr"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <EmployeeFormHR />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/SalaryManagement"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Salarymanagementhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/Salary-data"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Salarydatahr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/AttendanceManagement"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <AttandancecalendraHR />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/task-overview"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Taskoverviewhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/OfficeInventory"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <OfficeInventoryhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/Items-office-Inventory"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <ItemsofficeInventoryhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/LeaveManagement"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Balanceleavehr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/LeaveApproval"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Approvalhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/AddLeaveWFH"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <AddLeaveWFHhr />
          </ProtectedRoute>
        }
      />

      <Route
        path="/Hr/Review-Wfh"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Reviewwfhhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/ExpenseManagement"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <ExpenseDashboardHR />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/ViewSalaryExpenseHR"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <ViewSalaryExpenseHR />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/PayrollManagement"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Payrollprocesssalaryhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/ExpensePayroll"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Expensepayrollhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/Contract"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Contracthr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/GenerateArrear"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Salaryarrearhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/AccountLedger"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <AccountledgerHR />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/policy"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Privacypolicyhr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/inactive-employee"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Inactiveemployeehr />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Hr/Hr-settings"
        element={
          <ProtectedRoute allowedTypes={["H"]}>
            <Hrsetting />
          </ProtectedRoute>
        }
      />

      {/* employee routes */}
      <Route
        path="/Employee/dashboard"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <EmployeeDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/performance"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Perfomance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/salary-slip"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Salaryslipemployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/expense-tracking"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <TrackingEmployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/profile"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <ViewEmployeeprofile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/attendance-management"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <EmployeeAttendance />
          </ProtectedRoute>
        }
      />

      <Route
        path="/Employee/expense-management"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <ExpenseDashboardemployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/Viewexpanseemployee"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Viewexpanseemployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/add-leave-wfh"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <EmployeeLeave />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/Review-Wfh-Work-Update"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Reviewwfhupdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/create-workspace"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Createworkemployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/work-dashboard"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <WorkDashboardnew />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/Employeeworkspace"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Employeeworkspace />
          </ProtectedRoute>
        }
      />

      <Route
        path="/Employee/Subtask"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Subtask />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/Subtasks"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Subtasksemployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/loan-management"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Loanmanagementemployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/file"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
           <Filesharing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/Activity"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Activityemployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/Wfh_Work_Update"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Wfhworkupdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/task-overview"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <TaskOverview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/policy"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Privacypolicyemp />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/EPF"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <EPFcalculator />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Employee/setting"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Employeesetting />
          </ProtectedRoute>
        }
      />

      {/* <Route
        path="/Employee/Contract"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Contract />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/Employee/Leave-approval"
        element={
          <ProtectedRoute allowedTypes={["E"]}>
            <Approvalleave />
          </ProtectedRoute>
        }
      />

      {/* superadmin */}
      <Route
        path="/superadmin/dashboard"
        element={
          <ProtectedRoute allowedTypes={["S"]}>
            <Superadmindashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/superadmin/firm-dashboard"
        element={
          <ProtectedRoute allowedTypes={["S"]}>
            <Firmdashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/superadmin/firm-access"
        element={
          <ProtectedRoute allowedTypes={["S"]}>
            <Firmdaccess />
          </ProtectedRoute>
        }
      />
      <Route
        path="/superadmin/recent-query"
        element={
          <ProtectedRoute allowedTypes={["S"]}>
            <Reacentqueries />
          </ProtectedRoute>
        }
      />
      <Route
        path="/superadmin/login-query"
        element={
          <ProtectedRoute allowedTypes={["S"]}>
            <Loginqueries />
          </ProtectedRoute>
        }
      />
    </Route>
  </Routes>
);

export default AppRoutes;
